<div class="mt-4 px-0">
  <div class="glucose-report mb-5">
    <div class="glucose-report__header">
      <div>
        <div class="glucose-report__eyebrow">{{ "glucoseReport" | translate }}</div>
        <div class="glucose-report__subtitle">{{ followUpLabel }} . Aclik . Tokluk</div>
      </div>
      <div class="glucose-report__actions">
        <div class="month-switch" *ngIf="measurements?.length">
          <button
            type="button"
            class="month-switch__button"
            (click)="changeWeek(-1)"
            aria-label="Onceki hafta"
          >
            ‹
          </button>
          <span class="month-switch__label">{{ selectedWeekLabel }}</span>
          <button
            type="button"
            class="month-switch__button"
            (click)="changeWeek(1)"
            aria-label="Sonraki hafta"
          >
            ›
          </button>
        </div>
        <button
          type="button"
          class="btn btn-dark btn-sm cursor-pointer fw-bold fs-12"
          data-bs-toggle="modal"
          [attr.data-bs-target]="'#createQrCodeModal'"
          (click)="getQrCode()"
        >
          {{ "createQrCode" | translate }}
        </button>
      </div>
    </div>

    <div class="glucose-summary-grid" *ngIf="measurements?.length">
      <div class="summary-card">
        <div class="summary-card__title">Ortalama</div>
        <div class="summary-card__value">
          {{ chartSummary.average ?? 0 | number : "1.0-0" }}
          <span>mg/dL</span>
        </div>
        <div class="summary-card__hint" [ngClass]="averageStatusClass">
          {{ averageStatusText }}
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__title summary-card__title--with-info">
          <span>HbA1c (Lab)</span>
          <span
            class="summary-card__info"
            tabindex="0"
            role="note"
            aria-label="HbA1c referans araliklari"
          >
            i
            <span class="summary-card__tooltip">
              <span>&lt; 5.7% → Normal</span>
              <span>5.7-6.4% → Prediyabet riski</span>
              <span>6.5-6.9% → Hedef sınırında</span>
              <span>≥ 7.0% → Hedef üstü</span>
            </span>
          </span>
        </div>
        <div class="summary-card__value">
          {{ hba1cValue ?? 0 | number : "1.0-1" }}
          <span>%</span>
        </div>
        <div class="summary-card__hint" [ngClass]="hba1cStatusClass">
          {{ hba1cStatusText }}
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__title">Hedef aralikta</div>
        <div class="summary-card__value">
          {{ chartSummary.inRangePercentage | number : "1.0-0" }}
          <span>%</span>
        </div>
        <div class="summary-card__hint">
          {{ "targetBandLabel" | translate:{ lower: targetLowerLimit, upper: targetUpperLimit } }}
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__title">Yuksek / Dusuk</div>
        <div class="summary-card__split">
          <span class="status-high"
            >{{ chartSummary.highPercentage | number : "1.0-0" }}%</span
          >
          <span class="slash">/</span>
          <span class="status-low"
            >{{ chartSummary.lowPercentage | number : "1.0-0" }}%</span
          >
        </div>
        <div class="summary-card__hint">
          &gt;{{ targetUpperLimit }} / &lt;{{ targetLowerLimit }}
        </div>
      </div>
    </div>

    <div class="glucose-chart-card">
      <ng-container *ngIf="measurements?.length; else noChart">
        <div class="glucose-legend">
          <div class="glucose-legend__item">
            <span
              class="glucose-legend__swatch glucose-legend__swatch--fasting"
            ></span>
            <span>Aclik</span>
          </div>
          <div class="glucose-legend__item">
            <span
              class="glucose-legend__swatch glucose-legend__swatch--postprandial"
            ></span>
            <span>Tokluk</span>
          </div>
          <div class="glucose-legend__item">
            <span
              class="glucose-legend__swatch glucose-legend__swatch--band"
            ></span>
            <span>{{ "targetBandLegend" | translate:{ lower: targetLowerLimit, upper: targetUpperLimit } }}</span>
          </div>
        </div>

        <div class="glucose-chart-wrapper">
          <canvas
            baseChart
            [data]="chartData"
            [options]="chartOptions"
            [type]="'line'"
          >
          </canvas>
        </div>
      </ng-container>

      <ng-template #noChart>
        <p class="fs-14 mb-0">
          {{ "noChart" | translate }}
        </p>
      </ng-template>
    </div>
  </div>

  <div class="lifestyle-panel mb-5">
    <div class="lifestyle-panel__header">
      <div>
        <div class="lifestyle-panel__eyebrow">{{ "dailyRoutine" | translate }}</div>
        <div class="lifestyle-panel__subtitle">
          {{ "dailyRoutineSubtitle" | translate }}
        </div>
      </div>
    </div>

    <div class="lifestyle-grid">
      <div class="lifestyle-card" *ngFor="let item of lifestyleCards">
        <div class="lifestyle-card__label">{{ item.labelKey | translate }}</div>
        <div class="lifestyle-card__value">{{ item.value }}</div>
      </div>
    </div>
  </div>

  <div class="activity-log-panel mb-5">
    <div class="activity-log-panel__header">
      <div>
        <div class="activity-log-panel__eyebrow">{{ "mealConsumptionLogs" | translate }}</div>
        <div class="activity-log-panel__subtitle">
          {{ "mealConsumptionLogsSubtitle" | translate }}
        </div>
      </div>
    </div>

    <div class="activity-log-grid">
      <div class="activity-log-card" *ngFor="let section of mealTimelineSections">
        <div class="activity-log-card__title">
          <i [class]="section.icon"></i>
          <span>{{ section.labelKey | translate }}</span>
        </div>

        <ng-container *ngIf="section.entries.length; else noMealEntries">
          <div class="activity-log-list">
            <div class="activity-log-item" *ngFor="let entry of section.entries">
              {{ entry }}
            </div>
          </div>
        </ng-container>

        <ng-template #noMealEntries>
          <div class="activity-log-empty">{{ "noRecord" | translate }}</div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="activity-log-panel mb-5">
    <div class="activity-log-panel__header">
      <div>
        <div class="activity-log-panel__eyebrow">{{ "activityLogs" | translate }}</div>
        <div class="activity-log-panel__subtitle">
          {{ "activityLogsSubtitle" | translate }}
        </div>
      </div>
    </div>

    <div class="activity-log-grid">
      <div class="activity-log-card" *ngFor="let section of activityTimelineSections">
        <div class="activity-log-card__title">
          <i [class]="section.icon"></i>
          <span>{{ section.labelKey | translate }}</span>
        </div>

        <ng-container *ngIf="section.entries.length; else noActivityEntries">
          <div class="activity-log-list">
            <div class="activity-log-item" *ngFor="let entry of section.entries">
              {{ entry }}
            </div>
          </div>
        </ng-container>

        <ng-template #noActivityEntries>
          <div class="activity-log-empty">{{ "noRecord" | translate }}</div>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Have you ever been diagnosed with diabetes? -->
  <div class="mb-0">
    <label class="form-label fw-bold mb-3">{{
      "haveYouBeenDiagnosedWithDiabetes" | translate
    }}</label>
    <p>
      {{ checkYesOrNo(diabetesCaseInformation?.hasDiabetes) || "-" }}
    </p>
  </div>

  <ng-container *ngIf="diabetesCaseInformation?.hasDiabetes">
    <!-- Diyabetes Type -->
    <div class="mb-4">
      <label class="form-label fw-bold mb-3">{{
        "whatIsTheTypeOfDiabetes" | translate
      }}</label>
      <p>
        {{ diabetesCaseInformation?.diabetesType?.name || "-" }}
      </p>
    </div>

    <!-- When Were You Diagnosed? -->
    <div class="mb-4">
      <label class="form-label fw-bold mb-3">{{
        "whenWereYouDiagnosed" | translate
      }}</label>
      <p>
        {{ diabetesCaseInformation?.diagnosisDate | date : "dd-MM-yyyy" }}
      </p>
    </div>

    <!-- Are you taking medications for diabetes? -->
    <div class="mb-4">
      <label class="form-label fw-bold mb-3">{{
        "areYouTakingMedicationsForDiabetes" | translate
      }}</label>
      <ng-container
        *ngIf="
          diabetesCaseInformation?.medicationType?.none;
          else medicationList
        "
      >
        <div>{{ "none" | translate }}</div>
      </ng-container>

      <ng-template #medicationList>
        <p
          *ngIf="diabetesCaseInformation?.medicationType?.oralHypoglycemic"
          class="mb-2"
        >
          {{ "oralHypoglycemic" | translate }}
        </p>
        <p
          *ngIf="diabetesCaseInformation?.medicationType?.insulin"
          class="mb-2"
        >
          {{ "insulin" | translate }}
        </p>
      </ng-template>
    </div>

    <ng-container *ngIf="!diabetesCaseInformation?.medicationType?.none">
      <ng-container *ngIf="diabetesCaseInformation?.medicationType?.insulin">
        <!-- Insulin Administration Route -->
        <div class="mb-4">
          <label class="form-label fw-bold mb-3">{{
            "insulinAdministrationRoute" | translate
          }}</label>
          <p>
            {{
              checkInsulinAdministrationMethod(
                diabetesCaseInformation?.insulinAdministrationMethod
              )
            }}
          </p>
        </div>

        <!-- Insulin Schedule -->
        <div class="mb-4">
          <label class="form-label fw-bold mb-3">
            {{ "insulinSchedule" | translate }}
          </label>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ "time" | translate }}</th>
                  <th>{{ "insulinType" | translate }}</th>
                  <th>{{ "doseIU" | translate }}</th>
                  <th>{{ "time" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let insulinMedicationSchedule of sortedInsulinMedicationSchedules
                  "
                >
                  <td>
                    {{ checkTimePeriod(insulinMedicationSchedule.timePeriod) }}
                  </td>
                  <td>
                    {{ resolveInsulinTypeNames(insulinMedicationSchedule).join(", ") || "-" }}
                  </td>
                  <td>
                    {{ insulinMedicationSchedule.dosage ?? "-" }}
                  </td>
                  <td>
                    {{ normalizeDisplayTime(insulinMedicationSchedule.time) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="diabetesCaseInformation?.medicationType?.oralHypoglycemic"
      >
        <!-- Oral Hypoglycemic Schedule -->
        <div class="mb-4">
          <label class="form-label fw-bold mb-3">{{
            "oralHypoglycemicSchedule" | translate
          }}</label>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ "time" | translate }}</th>
                  <th>
                    {{ "medicineName" | translate }}
                  </th>
                  <th>{{ "doseIU" | translate }}</th>
                  <th>{{ "time" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let oralMedicationSchedule of sortedOralMedicationSchedules
                  "
                >
                  <td>
                    {{ checkTimePeriod(oralMedicationSchedule.timePeriod) }}
                  </td>
                  <td>
                    {{
                      oralMedicationSchedule.medicationName ??
                        oralMedicationSchedule.medicineName ??
                        oralMedicationSchedule.medicationId ??
                        "-"
                    }}
                  </td>
                  <td>
                    {{ oralMedicationSchedule.dosage ?? "-" }}
                  </td>
                  <td>
                    {{ normalizeDisplayTime(oralMedicationSchedule.time) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Lab Informations -->
  <div class="mb-4">
    <label class="form-label fw-bold mb-3">{{
      "labInformations" | translate
    }}</label>
    <div class="table-responsive">
      <table class="table table-bordered mb-0">
        <thead>
          <tr>
            <th>{{ "testDate" | translate }}</th>
            <th>
              {{ "timeOfDay" | translate }}
            </th>
            <th>{{ "hbA1cValue" | translate }}</th>
            <th>{{ "targetLowerLimit" | translate }}</th>
            <th>{{ "targetUpperLimit" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{
                diabetesCaseInformation?.laboratoryInformation?.testDate
                  | date : "dd-MM-yyyy"
              }}
            </td>
            <td>
              {{ diabetesCaseInformation?.laboratoryInformation?.testTime }}
            </td>
            <td>
              {{ diabetesCaseInformation?.laboratoryInformation?.hbA1CValue }}
            </td>
            <td>
              {{
                diabetesCaseInformation?.laboratoryInformation?.targetLowerLimit
              }}
            </td>
            <td>
              {{
                diabetesCaseInformation?.laboratoryInformation?.targetUpperLimit
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Other Important Chronic Diseases -->
  <div class="mb-4">
    <label class="form-label fw-bold mb-3">{{
      "otherImportantChronicDiseases.title" | translate
    }}</label>
    <div class="d-flex flex-column gap-3">
      <p>
        {{ displayDiabetesCaseInformation() }}
      </p>
    </div>
  </div>

  <!-- Other Medications -->
  <div class="mb-4" *ngIf="sortedOtherMedicationSchedules.length > 0">
    <label class="form-label fw-bold mb-3">{{
      "otherMedications" | translate
    }}</label>
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>{{ "time" | translate }}</th>
            <th>{{ "medicineName" | translate }}</th>
            <th>{{ "doseIU" | translate }}</th>
            <th>{{ "time" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let otherMedicationSchedule of sortedOtherMedicationSchedules
            "
          >
            <td>
              {{ checkTimePeriod(otherMedicationSchedule.timePeriod) }}
            </td>
            <td>
              {{ resolveOtherMedicationName(otherMedicationSchedule) }}
            </td>
            <td>
              {{ otherMedicationSchedule.dosage ?? "-" }}
            </td>
            <td>
              {{ otherMedicationSchedule.time ?? "-" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Create Qr Code Modal -->
<div
  class="modal fade"
  id="createQrCodeModal"
  tabindex="-1"
  aria-labelledby="createQrCodeModalLabel"
  aria-hidden="true"
>
<div class="modal-dialog modal-sm">
  <div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title fs-2" id="createQrCodeModalLabel">
        {{ "qrCode" | translate }}
      </h1>
      <button
        type="button"
        class="btn-close cursor-pointer"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>

    <div class="modal-body fs-4 text-center">
      <div
        *ngIf="!qrCodeDetails?.url; else showQrCode"
        class="spinner-border qr-code-spinner text-danger"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>

      <ng-template #showQrCode>
        <img [src]="qrCodeDetails.url" class="qr-code w-100 mb-4" alt="QR Code" />

        <!-- Hasta bilgileri QR kodun ALTINDA -->
        <div class="patient-info text-start">
          <div><strong>Ad Soyad:</strong> {{ patientHeaderInformations.name }}</div>
          <div><strong>Yaş:</strong> {{ patientHeaderInformations.age }}</div>
          <div><strong>Tarih:</strong> {{ patientHeaderInformations.CreatedDate | date:'dd.MM.yyyy' }}</div>
          <div><strong>Vaka No:</strong> {{ patientHeaderInformations.patientRecordCaseNumber }}</div>
        
        </div>
      </ng-template>
    </div>
  </div>
</div>

</div>
